import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { components } from './components';
import { DEFAULT_BORDER_RADIUS } from './constants';
import { palette } from './palette';
import { typography } from './typography';

export const createDefaultTheme = (useResponsiveFonts: boolean = true) => {
  let theme = createTheme({
    cssVariables: true,
    palette,
    typography,
    spacing: (factor: number) => `${factor / 16}rem`,
    shape: {
      borderRadius: DEFAULT_BORDER_RADIUS,
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1350,
        xl: 1700,
      },
    },
  });

  const shadows = theme.shadows;
  //Temporary solution wa
  shadows[4] = '0px 0px 5px 0px #00000014, 0px 1px 2px 0px #00000014';

  theme = createTheme(theme, { components, shadows });

  return useResponsiveFonts ? responsiveFontSizes(theme) : theme;
};

export const defaultTheme = createDefaultTheme();
export const fixedScaleTheme = createDefaultTheme(false);
